"use client";

import { c as _c } from "react/compiler-runtime";
import { Fragment } from "react";
import { Link } from "@/i18n/navigation";
import { useT } from "@/lib/i18n";
import { useBetaPrefix } from "@/lib/api/prefix.client";
import { characterName } from "@/app/components/CharacterTag";
import { pct, type EntitySummaryData, type SummaryLink } from "@/lib/entity-summary";
export default function EntitySummary(t0) {
  const $ = _c(28);
  const {
    name,
    data
  } = t0;
  const t = useT();
  const bp = useBetaPrefix();
  if (!data) {
    return null;
  }
  let t1;
  if ($[0] !== bp || $[1] !== t) {
    t1 = items => items.map((it, i) => <Fragment key={it.id}>{i > 0 && (i === items.length - 1 ? ` ${t("and")} ` : ", ")}<Link href={`${bp}/${it.kind}/${it.id.toLowerCase()}`} className="summary-link">{it.name}</Link></Fragment>);
    $[0] = bp;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const links = t1;
  const hasStats = data.runs !== null && data.winRate !== null && data.baseline !== null;
  const statsKey = data.pickRate !== null && data.pickRate > 0 ? "entity_summary_stats" : "entity_summary_stats_no_pick";
  let t2;
  if ($[3] !== data.baseline || $[4] !== data.bestCharacter || $[5] !== data.pickRate || $[6] !== data.runs || $[7] !== data.winRate || $[8] !== hasStats || $[9] !== name || $[10] !== statsKey || $[11] !== t) {
    t2 = hasStats && <>{t(statsKey, {
        runs: (data.runs ?? 0).toLocaleString(),
        name,
        winRate: pct(data.winRate ?? 0),
        baseline: pct(data.baseline ?? 0),
        pickRate: pct(data.pickRate ?? 0)
      })}{data.bestCharacter && <>{" "}{t("entity_summary_best_character", {
          character: t(characterName(data.bestCharacter.character)),
          winRate: pct(data.bestCharacter.winRate)
        })}</>}</>;
    $[3] = data.baseline;
    $[4] = data.bestCharacter;
    $[5] = data.pickRate;
    $[6] = data.runs;
    $[7] = data.winRate;
    $[8] = hasStats;
    $[9] = name;
    $[10] = statsKey;
    $[11] = t;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[13] !== data.partners || $[14] !== hasStats || $[15] !== links || $[16] !== t) {
    t3 = data.partners.length > 0 && <>{hasStats && " "}{t("entity_summary_partners_before")} {links(data.partners)}.</>;
    $[13] = data.partners;
    $[14] = hasStats;
    $[15] = links;
    $[16] = t;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  let t4;
  if ($[18] !== data.draftedNext || $[19] !== data.partners.length || $[20] !== hasStats || $[21] !== links || $[22] !== t) {
    t4 = data.draftedNext.length > 0 && <>{(hasStats || data.partners.length > 0) && " "}{t("entity_summary_drafted_before")} {links(data.draftedNext)}{" "}{t("entity_summary_drafted_after")}.</>;
    $[18] = data.draftedNext;
    $[19] = data.partners.length;
    $[20] = hasStats;
    $[21] = links;
    $[22] = t;
    $[23] = t4;
  } else {
    t4 = $[23];
  }
  let t5;
  if ($[24] !== t2 || $[25] !== t3 || $[26] !== t4) {
    t5 = <p className="entity-summary">{t2}{t3}{t4}</p>;
    $[24] = t2;
    $[25] = t3;
    $[26] = t4;
    $[27] = t5;
  } else {
    t5 = $[27];
  }
  return t5;
}